import { FC, Fragment, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { MultiValue } from 'react-select';

import { Divider } from '@hsp/react-component-library';

import { VirtualSelect } from 'components/select';
import { useFetchPackageTags } from 'pages/audience/shared/hooks/queries';
import { ISelectedFilter } from 'types/api/audience';
import { SearchType } from 'types/api/audience/enums';
import { ITag } from 'types/api/tag';
import { s } from 'utilities/strings';

const formName = `${SearchType.Tags}.packageTags`;

const PackageTags: FC = () => {
  const { getValues, setValue } = useFormContext();
  const { data: packageTags, isFetching } = useFetchPackageTags();

  const getValue = useCallback(() => {
    const current = getValues(formName) as ISelectedFilter<ITag>;

    return current;
  }, [getValues]);

  const handleSelected = useCallback(
    (options: MultiValue<ITag>) => {
      const current = getValue();

      setValue(formName, { ...current, filters: options });
    },
    [getValue, setValue]
  );

  const getPackageTagValue = useCallback(() => {
    const current = getValue();

    return packageTags?.filter((code) => (current?.filters ?? []).find((selected) => code.id === selected.id));
  }, [getValue, packageTags]);

  return (
    <Fragment>
      <div className="mb-3">
        <Divider>{s(['Site.Package', 'Site.Tag'], { plural: true })}</Divider>
      </div>
      <VirtualSelect
        closeMenuOnSelect={false}
        getOptionLabel={({ name }) => name}
        getOptionValue={({ id }) => id?.toString() ?? ''}
        isClearable
        isDisabled={isFetching}
        isLoading={isFetching}
        isMulti
        onChange={handleSelected}
        options={packageTags}
        placeholder={s('Site.Select')}
        value={getPackageTagValue()}
      />
    </Fragment>
  );
};

export default PackageTags;
